import { render, staticRenderFns } from "./MsgDetails.vue?vue&type=template&id=5b9d2972&scoped=true"
import script from "./MsgDetails.vue?vue&type=script&lang=js"
export * from "./MsgDetails.vue?vue&type=script&lang=js"
import style0 from "./MsgDetails.vue?vue&type=style&index=0&id=5b9d2972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d2972",
  null
  
)

export default component.exports